import {Moment} from 'moment';

export interface IDischargeCardData {
  date: Moment;
  waterLevel: number;
  discharge: number;
  freeRiverArea?: number;
  maximumDepth?: number;
}

export default class DischargeCardController {
  dischargeData: IDischargeCardData;
}



/** WEBPACK FOOTER **
 ** ./app/operational/input/kn15-telegram/discharge-card.controller.ts
 **/